import { ADD_ERROR, REMOVE_ERROR } from './errors-actions';

const initialState = [];

/**
 * Errors Reducer
 *
 * Consumes ADD_ERROR action
 * Consumes REMOVE_ERROR action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - the new state
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case ADD_ERROR:
            return [...state, action.payload];
        case REMOVE_ERROR:
            return state.slice(0, state.length - 1);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./containers/app/errors/errors-reducer.js